import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  updateCustomerLoginEmailField,
  updateCustomerLoginPasswordField,
  runCustomerLoginFormValidations,
  resetForm,
  setSelectedCountry,
} from '../../actions/index'
import { customerRegister } from '../../actions/apiRequest'
import RegForm from '../../components/RegistrationForm'
import { getCountries } from '../../actions/allCountries'

const mapStateToProps = (state) => ({
  ...state.loginForm,
  countriesOption: state.merchantCountries.allCountries,
  defaultCountry: state.merchant.home_country,
  selectedCountry: state.merchantCountries.selectedCountry,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  onEmailChange: (e) => {
    const email = e.target.value
    dispatch(updateCustomerLoginEmailField(email))
    dispatch(runCustomerLoginFormValidations())
  },
  onPasswordChange: (e) => {
    const password = e.target.value
    dispatch(updateCustomerLoginPasswordField(password))
    dispatch(runCustomerLoginFormValidations())
  },
  onSubmit: (e, params) => {
    e.preventDefault()
    dispatch(customerRegister(ownProps.history, params))
  },
  onLoadResetForm: () => {
    dispatch(resetForm())
  },
  fetchAllCountries: () => {
    dispatch(getCountries())
  },
  onCountryChange: (countryObj) => {
    dispatch(setSelectedCountry(countryObj))
  },
})

const RegisterForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegForm)

export default withRouter(RegisterForm)
